import { Alert } from "@icg360/ui-toolkit";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { closeMessage } from "../../store/messages";
import { dismissNotice } from "../../store/notices";
import { selectMessages } from "../../store/selectors";
import { selectPinnedNotices } from "../../store/selectors/notices";
import { useAppDispatch } from "../../hooks/redux";

import { TEMPLATE_TYPES } from "./constants";
import ReLogin from "./re-login";
import Refresh from "./refresh";

import type { Message, Notice } from "./types";
import type { ApState } from "../../store/root-reducer";

const TEMPLATE_MAP = {
  [TEMPLATE_TYPES.REFRESH]: Refresh,
  [TEMPLATE_TYPES.RELOGIN]: ReLogin
};

export const Messages = () => {
  const dispatch = useAppDispatch();
  const messages = useSelector(selectMessages) as Message[];
  // in typescript, we need this check to ensure that notices is in the redux store
  const hasNotices = useSelector((state: ApState) => !!state.notices);
  const notices = hasNotices
    ? (useSelector(selectPinnedNotices) as Notice[])
    : [];
  const handleClose = (message: Message) => dispatch(closeMessage(message));
  const handleCloseNotice = (id: number) => dispatch(dismissNotice(id));

  if (!messages.length && !notices.length) {
    return null;
  }
  return (
    <div className="HeaderMessages">
      {(messages as Message[]).map((message: Message, i: number) => {
        const {
          autoDismiss = false,
          closable = true,
          hasIcon = true,
          template,
          templateProps,
          text,
          type
        } = message;
        return (
          <Alert
            autoDismiss={autoDismiss}
            bsStyle={type}
            closeLabel="Close Message"
            hasIcon={hasIcon}
            onDismiss={closable ? () => handleClose(message) : undefined}
            key={i}
          >
            {template
              ? React.createElement(TEMPLATE_MAP[template], {
                  children: text,
                  ...templateProps
                })
              : text}
          </Alert>
        );
      })}
      {notices.map(({ id, alternateTitle, title, highlight }) => (
        <Alert
          className="notice-alert"
          closeLabel="Close Notice"
          onDismiss={() => handleCloseNotice(id)}
          key={id}
          data-highlight={highlight.color}
        >
          <strong>New Notice:</strong> {alternateTitle || title}{" "}
          <Link to={`/notices/${id}`} onClick={() => handleCloseNotice(id)}>
            Read more&hellip;
          </Link>
        </Alert>
      ))}
    </div>
  );
};
